import { render, staticRenderFns } from "./StatusBadge.vue?vue&type=template&id=ac61e35e&"
import script from "./StatusBadge.vue?vue&type=script&lang=js&"
export * from "./StatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports